import React from 'react';
import {Link, useLocation} from 'react-router-dom';

import './Intro.scss';

type EntryProps = {
    text : string
    uri : string
    size : 'sm' | 'lg'
}

export default function Intro({text, uri, size} : EntryProps) {
    const location = useLocation();

    return (
        <div className={'career-model__intro--outer-gradient size-' + size}>
            <div className="career-model__intro--outer-cover">
                <div className="career-model__intro--border">
                    <Link className="career-model__intro--link" to={uri}
                       state={{backgroundLocation: location}}>
                        <span className="career-model__intro--link-text" dangerouslySetInnerHTML={{__html: text}}></span>
                        <svg width={(size === 'sm') ? '30' : '50'} height={(size === 'sm') ? '30' : '50'} viewBox="0 0 50 40" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M30.2345 0.335449L27.5005 3.06949L42.2643 18.1067H0.706909V21.9344H42.2643L27.5005 36.9716L30.2345 39.7056L49.9196 20.0205L30.2345 0.335449Z"
                                  fill="white"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
    );
};
